<template>
  <div class="tools-partners-my-colabs">
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div v-else>
      <!-- desktop area -->
      <snow-data-table :columns="columns" :data="myColabs">
        <template #no-content-actions>
          <div class="bg-2 rounded-16 p-4 d-flex gap-3">
            <i class="ph ph-clock-countdown fs-32" />
            <div class="d-flex flex-column gap-1">
              <h6 class="text-semibold">Receber um convite</h6>
              <h6 class="text-dark-40">
                Aguarde ser convidado para ajudar a administrar um novo negócio
              </h6>
            </div>
          </div>
        </template>
      </snow-data-table>
      <div v-if="!loading" class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      page: 1,
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["myColabs"]),
    columns() {
      return [
        {
          name: "Usuário",
          field: "company",
          transform: company => company.name
        },
        {
          name: "Status",
          field: "is_blocked",
          transform: (_, item) => (item.is_blocked ? "Bloqueado" : "Aprovado"),
          class: (_, item) =>
            item.is_blocked ? "inactive-badge" : "active-badge"
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getMyColabs", { offset })
        .then(
          ({ count, next, previous }) =>
            (this.pagination = { count, next, previous })
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
